/**
 * Selected business date options for Date Showtime Picker component.
 */
export var DateShowtimePickerSelectedBusinessDate;
(function (DateShowtimePickerSelectedBusinessDate) {
    /**
     * Sets the initial selected business date to today's date.
     */
    DateShowtimePickerSelectedBusinessDate["Today"] = "Today";
    /**
     * Sets the initial selected business date to the first date with available showtimes.
     */
    DateShowtimePickerSelectedBusinessDate["NextAvailable"] = "NextAvailable";
})(DateShowtimePickerSelectedBusinessDate || (DateShowtimePickerSelectedBusinessDate = {}));
//# sourceMappingURL=selected-business-date.js.map